<template>
  <v-carousel
    class="mt-4"
    height="500px"
    width="700px"
    v-model="carousel"
    hide-delimiters
    cycle
  >
    <v-carousel-item v-for="(item, index) in items" :key="index">
      <v-row dense>
        <v-col cols="12">
          <v-card
            height="500"
            :color="carousel_color"
            dark
            elevation="6"
            class="mb-2"
          >
            <div class="d-flex flex-no-wrap justify-start">
              <div>
                <p class="black--text headline text-wrap ml-2 mt-16">
                  {{ item.title }}
                </p>
                <p class=" font-weight-black text-center">
                  <span class="h" style="color: #036c76"> {{ item.source }}</span>
                </p>
                
              </div>

              <v-avatar class="ma-3 mt-7" size="300" tile>
                <v-img :src="item.image"></v-img>
              </v-avatar>
            </div>
            <div class="row justify-content-center">
              <div class="col-12">
                <v-btn
                  class="blueblack--text ml-0 mt-5"
                  outlined
                  rounded
                  small
                  @click="selected = index"
                >
                  Read More
                </v-btn>
              </div>
            </div>

            <v-expand-transition>
              <v-card
                v-if="selected === index"
                class="white transition-fast-in-fast-out v-card--reveal scroll-vertical"
                style="height: 35%"
              >
                <v-card-text class="white pb-0">
                  <p class="black--text">{{ item.body }}</p>
                </v-card-text>
                <div class="row justify-content-center">
                  <div class="white col-12">
                    <v-btn text color="orange accent-4" @click="selected = -1">
                      Close
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  async created() {
    await this.fetchLatestNewsOR();
  },

  computed: {
    ...mapFields("news", ["latestNews"]),
  },
  data: () => ({
    carousel: 0,
    selected: -1,
    carousel_color: "white_darken",
    items: [],
  }),
  methods: {
    ...mapActions("news", {
      fetchLatestNewsOR: "fetchLatestNewsOR",
    }),
  },
  watch: {
    latestNews: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((news) => {
            this.items.push({
              image: news.image,
              title: news.title,
              body: news.body,
              source: news.source,
            });
          });
        }
      },
    },
  },
};
</script>